var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.6,136L325.6,136l60.6-70.9c7-8.6,5.7-21.2-2.8-28.2c-8.6-7-21.2-5.7-28.2,2.8L273.8,136H90.1 c-11.5,0-21.8,6.6-26.7,16.9c-5,10.3-3.4,22.6,3.8,31.4l83.6,102.1l-66.5,81.3c-7,8.6-5.7,21.2,2.8,28.2c3.7,3,8.2,4.5,12.7,4.5 c5.8,0,11.6-2.5,15.5-7.3l61.4-75v0L325.6,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.3,153c-4.9-10.4-15.2-16.9-26.7-16.9h-32.2L202.6,349.7v40.1v18.4c0,7.5,3.5,14.5,9.5,18.9l47.3,35.5 c7.2,5.4,16.7,6.2,24.8,2.2c8.1-4,13.1-12.2,13.1-21.1v-53.9v-40.1l135.2-165.3C439.7,175.5,441.2,163.3,436.3,153"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilter);
export default __webpack_public_path__ + "static/media/Reset-Filter.f096c40ba94c0004db4778211f21a2dd.svg";
export { ForwardRef as ReactComponent };